<template>
  <div class="yinsiCenter clearfix">
    <div class="aa">
      <ui-navigation></ui-navigation>
    </div>
    <div class="aboutBox">
      <div class="info">
        <h3 class="mb-4">雪帝网隐私保护声明</h3>
        <hr class="mb-4">
        <p>
          1.&nbsp;&nbsp;一切用户在下载并浏览软件时均被视为已经仔细阅读本条款并完全同意。凡以任何方式登陆本站软件，或直接、间接使用本软件资料者，均被视为自愿接受本网站相关声明和用户服务协议的约束。
        </p>
        <p>
          2.&nbsp;&nbsp;软件解密的文字、图片、音视频等资料均由本软件用户提供，其真实性、准确性和合法性由信息发布人负责。本网站不提供任何保证，并不承担任何法律责任。
        </p>
        <p>
          3.&nbsp;&nbsp;软件所解密的文字、图片、音视频等资料，如果侵犯了第三方的知识产权或其他权利，责任由作者或转载者本人承担，本网站对此不承担责任。
        </p>
        <p>
          4.&nbsp;&nbsp;本网站不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该外部链接指向的不由软件实际控制的任何网页上的内容，本网站不承担任何责任。
        </p>
        <p>
          5.&nbsp;&nbsp;除注明之服务条款外，其它因不当使用本网站软件而导致的任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的任何损失，本网站概不负责，亦不承担任何法律责任。
        </p>
        <p>
          6.&nbsp;&nbsp;对于因不可抗力或因黑客攻击、通讯线路中断等软件不能控制的原因造成的网络服务中断或其他缺陷，导致用户不能正常使用软件，本网站不承担任何责任。
        </p>
        <p>
          7.&nbsp;&nbsp;本声明未涉及的问题请参见国家有关法律法规，当本声明与国家有关法律法规冲突时，以国家法律法规为准。
        </p>
        <p>
          8.&nbsp;&nbsp;本网站相关声明版权及其修改权、更新权和最终解释权均属本公司所有。
        </p>
        <p>
          <br>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import Navigation from '@/components/about/Navigation.vue';

export default {
  name: 'yinsiCenter',
  mixins: [generalMix],
  data () {
    return {
    }
  },
  components:{
    'ui-navigation': Navigation
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style scoped lang='less'>
.yinsiCenter{
  display: flex;
  div.aa{
    width: 200px;
    margin-right: 30px;
    ul{
      margin-bottom: 10px;
      li{
        line-height: 2.8em;
        margin-bottom: 5px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        color: rgba(0,0,0,0.6);
        &.title{
          font-size: 1.3em;
          border-radius: 0;
          cursor: default;
          color: #000000;
          font-weight: bold;
          &:hover{
            background: none;
          }
        }
        &.active{
          background-color:rgba(0,0,0,0.1);
          background: #FFFFFF;
          color: #000000;
        }
        &:hover{
          background-color: #FFFFFF;
          color: #000000;
        }
        &:last-child{
          margin: 0;
        }
      }
    }
  }
  div.aboutBox{
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 30px;
    h1{
      font-size: 32px;
      color: #FF7B00;
    }
    ul{
      list-style: disc;
      padding-left: 30px;
    }
  }
}
@media (max-width: 992px) {
  .yinsiCenter{
    flex-direction: column;
    div.aa{
      margin: 0;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Yinsi.vue